import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "@/data/content";
import { FadeUp, SectionHead } from "./Reveal";

const CHAPTERS = [
  {
    n: "٠١",
    title: "أصل ثابت",
    text: "في شيادن الأصول العقارية نقدم حلولًا في التسويق والوساطة والتأجير للغير، مبنية على الثقة والوضوح.",
  },
  {
    n: "٠٢",
    title: "وضوح قبل كل شيء",
    text: "نهتم بتقديم تجربة واضحة واحترافية، بلا تعقيد ولا وعود فضفاضة — خطوات مفهومة من أول تواصل.",
  },
  {
    n: "٠٣",
    title: "كفاءة تصل بك",
    text: "نساعد عملاءنا على الوصول إلى احتياجاتهم العقارية بكفاءة، سواء كانوا باحثين عن عقار أو ملاكًا.",
  },
];

export default function About() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="about" data-testid="about-section" className="bg-cream py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <SectionHead eyebrow="WHO WE ARE" eyebrowAr="من نحن" title="منشأة عقارية بُنيت على الوضوح" testId="about-heading" />

        <div className="grid items-start gap-14 lg:grid-cols-2 lg:gap-20">
          <div>
            {CHAPTERS.map((c, i) => (
              <FadeUp key={c.n} delay={i * 0.12}>
                <div
                  data-testid={`about-chapter-${i + 1}`}
                  className="group flex gap-6 border-t border-ink/10 py-8 transition-colors duration-500 first:border-t-0 first:pt-0 hover:border-copper/50 md:gap-10 md:py-10"
                >
                  <span className="font-display text-3xl md:text-5xl font-semibold text-copper/80 transition-colors duration-500 group-hover:text-copper">
                    {c.n}
                  </span>
                  <div>
                    <h3 className="font-head text-xl md:text-2xl font-bold text-navy">{c.title}</h3>
                    <p className="mt-3 max-w-md text-sm md:text-base leading-relaxed text-ink/65">
                      {c.text}
                    </p>
                  </div>
                </div>
              </FadeUp>
            ))}
          </div>

          <FadeUp delay={0.15} className="relative">
            <div ref={ref} className="relative">
              <div className="absolute -end-3 -top-3 h-full w-full border border-copper/50" aria-hidden="true" />
              <div className="relative overflow-hidden">
                <motion.img
                  style={{ y: imgY }}
                  src={IMAGES.about}
                  alt="فيلا عصرية مضاءة وقت الغروب تعكس معايير شيادن في اختيار العقارات"
                  className="aspect-[4/5] w-full scale-110 object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-navy/15" />
              </div>
              <div className="absolute -bottom-6 -start-3 bg-navy px-6 py-5 md:-start-8">
                <span className="block font-display text-sm tracking-[0.3em] text-copper">EST. VISION</span>
                <span className="mt-1 block font-head text-lg font-bold text-cream">
                  قرارك العقاري يستحق أصلًا ثابتًا
                </span>
              </div>
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
